var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile-checker"}},[_c('pre',[_vm._v("    "),_vm._v("\n    "),_c('code',{domProps:{"innerHTML":_vm._s(_vm.profileData)}}),_vm._v("\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }